export const iconValues = [
	'',
	'arrowBack',
	'death',
	'broom',
	'check',
	'checkAll',
	'giftcard',
	'checkList',
	'loading',
	'question',
	'arrowComeBack',
	'creditCard',
	'giftcardDeco',
	'crown',
	'cup',
	'lock',
	'cookie',
	'text',
	'logoSquare',
	'noWifi',
	'unread',
	'reservatooLogo',
	'calculator',
	'sleep',
	'bang',
	'send',
	'alarm',
	'hourglass',
	'plan',
	'creditCardRefresh',
	'coffee',
	'stars',
	'squares',
	'cross',
	'ghost',
	'creditCardLock',
	'creditCardCross',
	'creditCardCheck',
	'rightHand',
	'internetEarth',
	'magnify',
	'minus',
	'magnifyHappy',
	'logoWhite',
	'stats',
	'history',
	'bell',
	'walk',
	'basket',
	'spam',
	'spam-accepted',
	'crossCircleClose',
	'keyProtected',
	'note',
	'wheel',
	'bubble',
	'input',
	'new',
	'customerSpeaking',
	'laptopBroken',
	'person',
	'dotsHorizontal',
	'debit',
	'burgerButton',
	'eyeClosed',
	'lightning',
	'plus',
	'discount',
	'calendar',
	'tablet',
	'desktop',
	'wind',
	'printer',
	'coins',
	'eyeOpened',
	'invoice',
	'list',
	'star',
	'popup',
	'edit',
	'arrowLeft',
	'arrowRight',
	'arrowUp',
	'arrowDown',
	'arrowDouble',
	'arrow',
	'checkbox',
	'moneyBag',
	'offer',
	'dot',
	'arrowDownDouble',
	'dotbig',
	'denied',
	'bank',
	'upgrade',
	'reset',
	'target',
	'chat',
	'group',
	'mobile',
	'arrowCollapse',
	'cashmachine',
	'checkbox-simple',
	'clap',
	'clock',
	'cloud',
	'filter',
	'garden',
	'google',
	'google-agenda',
	'incognito',
	'people',
	'personlove',
	'pin',
	'book',
	'triangle',
	'photo',
	'floppy',
	'copy',
	'paste',
	'closed',
	'company',
	'trash',
	'session',
	'paint',
	'flag',
	'number',
	'light',
	'moon',
	'publish',
	'laptopSetting',
	'collapse',
	'expand',
	'export',
	'login',
	'magicWand',
	'sound',
	'renewal',
	'pushNotification',
	'email',
	'dots',
	'fullscreen',
	'hello',
	'speedometer',
	'clear',
	'victory',
	'camera',
	'pause',
	'play',
	'stop',
	'qrcode',
	'moneyback',
	'swords'
];

import { icons } from '@lucide/svelte';

export type Icon = (typeof iconValues)[number] | keyof typeof icons;
